export default __webpack_public_path__ + "288c010b6ac806030923fd14babe23ee.svg";